import Default from "@/Layouts/Default";
import Hero from "@/Sections/Hero";
import { Head } from "@inertiajs/inertia-react";
import Contact from "@/Sections/Contact";
import React from "react";

export default function AboutPage({ blogs }) {
    const results = [
        {
            srcSet: "/assets/transformations/webp/personal-training-uden-schijndel-77.webp",
            src: "/assets/transformations/personal-training-uden-schijndel-77.jpg",
        },
        {
            srcSet: "/assets/transformations/webp/personal-training-uden-schijndel-102.webp",
            src: "/assets/transformations/personal-training-uden-schijndel-102.jpg",
        },
        {
            srcSet: "/assets/transformations/webp/personal-training-uden-schijndel-114.webp",
            src: "/assets/transformations/personal-training-uden-schijndel-114.jpg",
        },
        {
            srcSet: "/assets/transformations/webp/personal-training-uden-schijndel-115.webp",
            src: "/assets/transformations/personal-training-uden-schijndel-115.jpg",
        },
    ];

    return (
        <Default>
            <Head>
                <title>
                    Bedrijfsfitness - WE ARE Personal Training Uden en Schijndel
                </title>
                <link rel="canonical" href={route("business")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Jouw transformatie binnen 12 weken? Bij WE ARE personal training Uden en Schijndel regelen we het! Geen resultaat = geld terug!"
                />
                <meta
                    property="og:description"
                    content="Jouw transformatie binnen 12 weken? Bij WE ARE personal training Uden en Schijndel regelen we het! Geen resultaat = geld terug!"
                />
                <meta property="og:url" content={route("business")} />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Bedrijfsfitness - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                <Hero homepage={false} header={"Fit moms!"}></Hero>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                    <div className="max-w-4xl mx-auto text-center">
                        <h2 className="block text-white mx-auto font-custom italic font-bold uppercase max-w-4xl xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl mt-8">
                            De kracht van bewegen tijdens en na de zwangerschap
                        </h2>
                        <p className="mt-4 text-lg text-gray-100">
                            Veel vrouwen beschouwen de bevalling als een van de
                            meest unieke en prachtige momenten in hun leven.
                            Tegelijkertijd is het ook een van de meest
                            uitdagende ervaringen die je als vrouw kunt
                            ondergaan. Je kunt een bevalling vergelijken met het
                            leveren van een topprestatie in de sport. En net als
                            bij sport, is een grondige voorbereiding en training
                            cruciaal. Onze WE ARE FIT MOM'S biedt jou hierin de
                            hulp die je nodig hebt! 
                        </p>
                    </div>

                    <div className="overflow-hidden py-24 sm:py-32">
                        <div className="mx-auto max-w-7xl px-6 lg:px-8">
                            <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                De{" "}
                                <span className="text-we-are-yellow">
                                    voordelen
                                </span>{" "}
                                van sporten tijdens en na de{" "}
                                <span className="text-we-are-yellow">
                                    zwangerschap
                                </span>
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Onderzoek heeft aangetoond dat regelmatig
                                bewegen tijdens je zwangerschap en in de periode
                                erna veel positieve effecten heeft. Noors
                                onderzoek in 2015 laat zien dat vrouwen die drie
                                keer per week redelijk intensief sporten 14%
                                minder kans hebben op het krijgen van
                                bekkenpijn. Maar ook het risico op klachten als
                                hoge bloeddruk, zwangerschapsdiabetes en
                                vermoeidheid zijn veel minder als je regelmatig
                                sport als je zwanger bent.
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Verder bleek uit een onderzoek van de Technische
                                Universiteit van Madrid dat vrouwen die licht
                                intensief blijven sporten tijdens de
                                zwangerschap een minder lange bevalling hebben.
                                Zowel de ontsluitingsfase als de geboorte duurde
                                significant minder lang. Ook bleken deze vrouwen
                                minder last te hebben van pijn tijdens de
                                bevalling. Zij hadden aanzienlijk minder
                                pijnbestrijding nodig dan de vrouwen die niet
                                hadden gesport tijdens de zwangerschap.
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Naast deze onderzoeken zijn er ook nog meerdere
                                voordelen tijdens en na de zwangerschap zoals:
                            </p>
                            <ul className="mt-6 text-lg leading-8 text-white list-disc">
                                <li>
                                    Een gezondere gewichtstoename tijdens de
                                    zwangerschap
                                </li>
                                <li>Een positievere en sterkere mindset</li>
                                <li>Meer zelfvertrouwen</li>
                                <li>Een verbeterde lichaamshouding</li>
                                <li>Sneller herstel na de bevalling</li>
                                <li>
                                    Je bent sneller terug op je oude gewicht
                                </li>
                                <li>Minder kans op een postnatale depressie</li>
                            </ul>
                        </div>
                        <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-24 xs:mt-8 sm:mt-8 md:mt-24 lg:mt-24">
                            <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                Voor wie is{" "}
                                <span className="text-we-are-yellow">
                                    WE ARE FIT MOMS
                                </span>
                                ?
                            </p>

                            <p className="mt-6 text-lg leading-8 text-white">
                                Ons programma is geschikt voor twee groepen
                                vrouwen:
                            </p>
                            <ol className="mt-6 text-lg leading-8 text-white list-decimal">
                                <li>
                                    Zwangere vrouwen die graag fit willen
                                    blijven tijdens hun zwangerschap
                                </li>
                                <li>
                                    Pas bevallen vrouwen die onder professionele
                                    begeleiding weer terug op hun oude gewicht
                                    willen komen of zelfs beter!
                                </li>
                            </ol>
                        </div>
                        {/*  */}
                        <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-24 xs:mt-8 sm:mt-8 md:mt-24 lg:mt-24">
                            <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                Ontdek meer
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Wil je meer weten over fit blijven tijdens en na
                                je zwangerschap? Bekijk dan onze gratis blogs en
                                podcast. Laat je inspireren door de verhalen van
                                andere fitte moeders en ontdek hoe jij ook een
                                fit mom kunt worden!
                            </p>
                        </div>
                        {/*  */}
                        <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
                            <div className="text-center">
                                <p className="text-8xl tracking-tight font-extrabold italic uppercase font-custom text-white sm:text-8xl md:text-8xl lg:text-8xl xl:text-8xl">
                                    <span className="text-we-are-yellow">
                                        We{" "}
                                    </span>
                                    <span className="text-we-are-purple">
                                        Are
                                    </span>
                                </p>
                                <h2 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl">
                                    Results
                                </h2>
                                <div
                                    role="list"
                                    className="grid grid-cols-2 gap-x-4 gap-y-8 xs:grid-cols-[1 sm:grid-cols-1 sm:gap-x-6 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 xl:gap-x-8 mt-24"
                                >
                                    {results.map((x, i) => (
                                        <div className="relative p-2 lg:px-4 mx-auto">
                                            <div
                                                className={
                                                    "group block w-full rounded-lg bg-black"
                                                }
                                            >
                                                <picture>
                                                    <source
                                                        srcSet={x.srcSet}
                                                        width="480"
                                                        height="480"
                                                        type="image/webp"
                                                        alt={
                                                            "Transformatie " +
                                                            (1 + i)
                                                        }
                                                        className="object-cover pointer-events-none"
                                                    />
                                                    <source
                                                        srcSet={x.src}
                                                        width="480"
                                                        height="480"
                                                        type="image/jpeg"
                                                        alt={
                                                            "Transformatie " +
                                                            (1 + i)
                                                        }
                                                        className="object-cover pointer-events-none"
                                                    />
                                                    <img
                                                        src={x.src}
                                                        width="480"
                                                        height="480"
                                                        alt={
                                                            "Transformatie " +
                                                            (1 + i)
                                                        }
                                                        className="object-cover pointer-events-none"
                                                    />
                                                </picture>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {/*  */}
                        <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
                            <div className="text-center">
                                <p className="text-8xl tracking-tight font-extrabold italic uppercase font-custom text-white sm:text-8xl md:text-8xl lg:text-8xl xl:text-8xl">
                                    <span className="text-we-are-yellow">
                                        We{" "}
                                    </span>
                                    <span className="text-we-are-purple">
                                        Are
                                    </span>
                                </p>
                                <h2 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl">
                                    Stories
                                </h2>
                            </div>
                            <div className="gap-4 grid grid-cols-1 sm:grid-cols-2 mt-24">
                                <iframe
                                    style={{
                                        borderRadius: "12px",
                                    }}
                                    src="https://open.spotify.com/embed/episode/4Sf5GIsbNXaW24jzvo6zzt?si=99486186fe4948d7"
                                    width="100%"
                                    height="232"
                                    padding="10px"
                                    frameBorder="0"
                                    allowFullScreen
                                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                                ></iframe>
                                <iframe
                                    style={{
                                        borderRadius: "12px",
                                    }}
                                    src="https://open.spotify.com/embed/episode/0eCw6ksUCgUEzL6wp8D0V4?si=8a0a71c4aed648d4"
                                    width="100%"
                                    height="232"
                                    padding="10px"
                                    frameBorder="0"
                                    allowFullScreen
                                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                                ></iframe>
                            </div>
                        </div>
                        {/*  */}
                        <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
                            <div className="text-center">
                                <p className="text-8xl tracking-tight font-extrabold italic uppercase font-custom text-white sm:text-8xl md:text-8xl lg:text-8xl xl:text-8xl">
                                    <span className="text-we-are-yellow">
                                        We{" "}
                                    </span>
                                    <span className="text-we-are-purple">
                                        Are
                                    </span>
                                </p>
                                <h2 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl">
                                    Knowledge
                                </h2>
                            </div>
                        </div>

                        <div className="mt-6 max-w-lg mx-auto grid gap-5 lg:grid-cols-2 lg:max-w-none">
                            {blogs.map((post) => (
                                <div
                                    key={post.title}
                                    className="flex flex-col rounded-lg shadow-lg overflow-hidden"
                                >
                                    <div className="flex-shrink-0">
                                        <a href={post.href}>
                                            <picture>
                                                <source
                                                    srcSet={post.src_webp}
                                                    type="image/webp"
                                                    className="min-w-full"
                                                />
                                                <source
                                                    srcSet={post.src}
                                                    type="image/jpeg"
                                                    className="min-w-full"
                                                />
                                                <img
                                                    src={post.src}
                                                    className="min-w-full"
                                                />
                                            </picture>
                                        </a>
                                    </div>
                                    <div className="flex-1 bg-gray-900 p-6 flex flex-col justify-between">
                                        <div className="flex-1">
                                            <p className="text-sm font-medium text-we-are-purple">
                                                <a
                                                    href={post.href}
                                                    className="hover:underline"
                                                >
                                                    {post.name}
                                                </a>
                                            </p>
                                            <div
                                                href={post.href}
                                                className="block mt-2"
                                            >
                                                <a
                                                    href={post.href}
                                                    className="text-xl font-semibold text-gray-100"
                                                >
                                                    {post.title}
                                                </a>
                                                <p className="mt-3 text-base text-gray-100">
                                                    {post.description}
                                                </p>
                                                <a
                                                    href={post.href}
                                                    className="inline-flex items-center justify-center cursor-pointer py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-we-are-yellow "
                                                >
                                                    Lees meer
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <Contact />
            </div>
        </Default>
    );
}
